import React, {Fragment} from 'react';
import {
    Button,
    Form,
    Input,
    Modal,
    notification,
    Select,
    Typography,
    Timeline,
    Spin,
    Card,
    Descriptions,
    Tag, Col
} from "antd";

import ApiService from "../../../services/ApiService"

import {
    CreditCardOutlined,
    FormOutlined,
    EuroCircleOutlined,
    DownloadOutlined,
    SwapRightOutlined,
    EyeOutlined,
    EnvironmentOutlined, FieldTimeOutlined, CommentOutlined, PlusOutlined
} from "@ant-design/icons"
import moment from "moment";
import {APP_PREFIX_PATH} from "../../../configs/AppConfig";
import {Link} from "react-router-dom";
import {translateMethod, translateType} from "../paiements/functions";
import {isMobile} from "react-device-detect";
import CardCom from "./CardCom";
import ModalAddCom from "./ModalAddCom";
import {currencyFormat} from "../../../components/permissions/functions";
import {Trans} from "@lingui/react/macro";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalActivity extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: true,
        contact: null,
        data: [],
    };

    state = this.initialState;

    async show(contact) {
        this.setState({visible: true, contact: contact}, () => this.getData(contact))
    }

    close() {
        this.setState(this.initialState)
    }


    async getData(contact) {

        this.setState({loading: true})

        var res = await ApiService.get("/contact/activity/" + contact)
        console.log(res)

        this.setState({loading: false, data: res.data})
    }

    render() {

        return (
            <Fragment>
                <Modal width="100%" title={<Trans>Dernières Interactions</Trans>}
                       open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>

                    <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 20}}>
                        <Button type="primary" icon={<PlusOutlined/>}
                                onClick={() => this.modalAddCom.show(this.state.contact)}><Trans>Ajouter une activité</Trans></Button>
                    </Col>

                    <Spin spinning={this.state.loading}>
                        <Timeline mode={isMobile ? "left" : "alternate"}>
                            {this.state.data.map(item => {
                                let icon = null
                                let color = null
                                let title = null
                                let link = "#"
                                let descriptions = []

                                if (item.type === "PAIEMENT") {
                                    link = APP_PREFIX_PATH + "/paiements/list?search=" + item.id
                                    title = item.data.name

                                    descriptions = [
                                        {
                                            label: <Trans>Montant</Trans>,
                                            value: <Text type={"success"}>{currencyFormat(item.data.amount / 100)}</Text>
                                        },
                                        {
                                            label: <Trans>Moyen de paiement</Trans>,
                                            value: <Tag color="volcano">{translateMethod(item.data.method)}</Tag>
                                        },
                                        {
                                            label: <Trans>Type</Trans>,
                                            value: <Tag color="purple">{translateType(item.data.type, item.data)}</Tag>
                                        },
                                        {label: <Trans>Source</Trans>, value: <Tag color="blue">{item.data.source}</Tag>},
                                    ]

                                    if (item.data.commentaire) {
                                        descriptions.push({label: <Trans>Commentaire</Trans>, value: item.data.commentaire})
                                    }

                                    if (item.data.method === "CB") {
                                        icon = <CreditCardOutlined/>
                                        color = "#8E44AD"
                                    }

                                    if (item.data.method === "CASH") {
                                        icon = <EuroCircleOutlined/>
                                        color = "#138D75"
                                    }

                                    if (item.data.method === "PRELEVEMENT") {
                                        icon = <DownloadOutlined/>
                                        color = "#2980B9"
                                    }

                                    if (item.data.method === "VIREMENT") {
                                        icon = <SwapRightOutlined/>
                                        color = "#2980B9"
                                    }

                                }
                                if (item.type === "FORM") {
                                    link = APP_PREFIX_PATH + "/form/submit?label=" + encodeURI(item.data.formData.title) + "&id=" + item.data.form + "&search=" + item.id
                                    title = <Trans>Soumission : {item.data.formData.title}</Trans>
                                    color = "#F39C12"
                                    icon = <FormOutlined/>
                                }

                                if (item.type === "COM") {
                                    color = "rgb(196, 29, 127)"
                                    title = <Trans>Activité : {moment("DD/MM/YYYY à HH:mm")}</Trans>

                                    if (item.data.type === "VISITE") {
                                        icon = <EnvironmentOutlined/>
                                    }

                                    if (item.data.type === "RDV") {
                                        icon = <CommentOutlined/>
                                    }

                                    if (item.data.type === "AUTRE") {
                                        icon = <FieldTimeOutlined/>
                                    }
                                }

                                return (
                                    <Timeline.Item dot={icon} color={color}>
                                        <div style={{textAlign: "left"}}>
                                            {item.type === "COM" ? (
                                                <CardCom contact={this.state.contact} item={item.data}
                                                         editable={false}/>
                                            ) : (
                                                <Card title={title} extra={(
                                                    <Link to={link} target="_blank"><Button
                                                        icon={<EyeOutlined/>}/></Link>
                                                )}>
                                                    {descriptions.length > 0 && (
                                                        <Descriptions title={<Trans>Informations</Trans>} bordered column={1}
                                                                      style={{marginBottom: 20}}>
                                                            {descriptions.map(item => (
                                                                <Descriptions.Item
                                                                    label={item.label}>{item.value}</Descriptions.Item>
                                                            ))}
                                                        </Descriptions>
                                                    )}

                                                    <div style={{textAlign: "right"}}>
                                                        <Text
                                                            type="secondary">{moment(item.datetime).format("dddd DD MMMM YYYY à HH:mm")}</Text>
                                                    </div>

                                                </Card>
                                            )}
                                        </div>
                                    </Timeline.Item>
                                )
                            })}
                        </Timeline>
                    </Spin>
                </Modal>
                <ModalAddCom getRef={(ref) => this.modalAddCom = ref} onFinish={() => this.getData()}/>
            </Fragment>
        )
    }
}
